<template>
  <div v-if="tags.length" class="tag-pos-legend" :class="containerClass">
    <span
      v-for="tag in tags"
      :key="tag.id"
      class="tag-pos-legend-item"
    >
      <span
        class="tag-pos-legend-dot"
        :style="{ backgroundColor: tag.color }"
      />
      <span class="tag-pos-legend-label">{{ tag.label }}</span>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tagPosCatalog: {
    type: Object,
    required: false,
    default: () => ({})
  },
  containerClass: {
    type: String,
    required: false,
    default: ''
  }
});

const tags = computed(() => {
  if (!props.tagPosCatalog) return [];
  return Object.values(props.tagPosCatalog).filter(tag => tag && tag.color);
});
</script>

<style scoped>
.tag-pos-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
}

.tag-pos-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.tag-pos-legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tag-pos-legend-label {
  font-size: 0.8rem;
  color: #555;
}

.tag-pos-legend-sticky {
  position: sticky;
  top: -8px;
  z-index: 1;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
</style>


